module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['companyGroup'],
      "atferSave": _vm.atferSave,
      "form-order": _vm.formOrder
    },
    scopedSlots: _vm._u([{
      key: "recordingsSize",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(_vm.$format.ratio(row.item.recordingsSize, row.item.quota * (1024 * 1024))) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6efa12da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Companies.vue
// module id = 1081
// module chunks = 1